import { Injectable, TemplateRef } from '@angular/core';
import { POPUP_ALERT_TYPE } from './vg-popup-alert';
import { VgPopupAlertComponent } from './vg-popup-alert.component';
import { VlWindowRef, VlWindowService } from 'vl-tailwind-layout';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class VgPopupAlertService {
    private windowRef: VlWindowRef = null;
    private destroy$: Subject<void> = new Subject();

    constructor(private vlWindowService: VlWindowService) { }

    public open(type: POPUP_ALERT_TYPE, message: string, template?: TemplateRef<any>, time?: number, klass?: string): void {
        try {
            time = time ? time * 1000 : 2 * 1000;

            klass = !klass ? 'no-header' : `${klass} no-header`;

            this.windowRef = this.vlWindowService.open(VgPopupAlertComponent, {
                title: "",
                context: {
                    template: template,
                    type: type,
                    message: message
                },
                class: klass,
                resizable: false,
            });

            this.windowRef.onClose
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                    this.destroy();
                });

            timer(time)
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                    this.close();
                });
        } catch (error) {

        }
    }

    public close(): void {
        this.windowRef?.close();
        this.destroy();
    }

    private destroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        delete this.windowRef;
    }
}